import {styled} from '@mui/material'
import Table from 'components/Display/Table'
import {useParams} from 'react-router-dom'
import {useDeviceDetect} from 'services/hooks'
import {useGetClientRequestsQuery} from 'store/Store'

const RequestsHistory = () => {
    const {clientId} = useParams()
    const {isMobile} = useDeviceDetect()

    return (
        <Container isMobile={isMobile}>
            <Table
                useSearch={false}
                itemName="clientRequest"
                itemKey="PlannerClientKey"
                useGetQuery={useGetClientRequestsQuery}
                queryId={clientId}
                TableTitleComponent={() => <></>}
            />
        </Container>
    )
}

export default RequestsHistory

const Container = styled('div')`
    display: flex;
    padding-block: 12px;
    gap: 100px;
    height: 100%;
    width: ${({isMobile}) => (isMobile ? 100 : 60)}%;
`
